(() => {
  let observed;
  const resize = new ResizeObserver(update);
  function update() {
    const wrapper = document.querySelector('#PBarNextFrameWrapper');
    if (wrapper !== observed) {
      resize.disconnect();
      if (wrapper) resize.observe(wrapper);
      observed = wrapper;
    }
    const height = wrapper ? Math.max(0, wrapper.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--mom-preview-bar-height', `${height}px`);
  }
  new MutationObserver(update).observe(document.body, { childList: true });
  window.addEventListener('resize', update);
  update();
})();
